export default "__VITE_ASSET__DnWSXsV8__"